import { ChangeDetectorRef, Component, EventEmitter, Output } from "@angular/core";
import {
  GenerateUWDocumentRequest, GetALLCoveragesDetailResponse, GetAllRateAgainstPackageResponse, GetCountryDetailbyAreaResponse,
  GetCoveragesDetailbyAreaRequest, GetPackagesDetailByTravelPeriodWithCovidRequest, GetPackagesDetailByTravelPeriodWithCovidResponse
  , GetAllRateAgainstPackageRequest, GetCountryDetailbyAreaRequest, GetCoveragesDetailByAreaResponse, GetPolicyReportRequest, GetPolicyReportResponse,
  GetRequestedUWDocumentDataRequest, GetRequestedUWDocumentDataResponse, GetURLForPolicyPrintRequest, GetURLForPolicyPrintResponse, GenerateUWDocumentResponse, ProcessUWRequestDataRequest, TravelInsuranceDataProps, ProcessUWRequestDataResponse,
  UnitedPassengersBaseProperties,
  UnitedPassengerProperties,
  DBInsertProps,
  InsuranceRights,
  InsuranceRightsObject
} from '../Models/TravelInsuranceProperties';
import { PassengerInfoService } from "../Services/passengerInfo.service";
import { DatePipe } from "@angular/common";
import { AirSegmentStopDetail, AirSegmentsDetails, BookingBasicProperties } from "../Models/FlightSearchProperties";
import { BookingInfoProperties, BookingPassengerInfoProperties } from "../Models/BookingPassengerTicketIssuanceProperties";
//import { lastValueFrom } from "rxjs";
import { FlightSearchService } from "../Services/FlightSearch.service";
import { faArrowRight, faUpRightFromSquare, faReply, faCheck, faLink, faLock, faClock } from '@fortawesome/free-solid-svg-icons';
import { NgForm } from "@angular/forms";
import { NavigationStart, Router } from "@angular/router";
import { Countries } from "../Models/Countries";
import { parse } from "@fortawesome/fontawesome-svg-core";
import { AgencyService } from "../Services/Agency.service";
import { InsuranceService } from "../Services/insurance-service.service";
import * as $ from 'jquery';
import { MessageService } from "primeng/api";

@Component({
  selector: 'app-united-insurance',
  templateUrl: './united-insurance.component.html',
  styleUrls: ['./united-insurance.component.css']
})
export class UnitedInsuranceComponent {
  passengerInfoBaseObj = new UnitedPassengersBaseProperties();
  spouseObj = new BookingPassengerInfoProperties();
  childrenToBeInsured: BookingPassengerInfoProperties[]=[];
  airSegmentDetails: AirSegmentsDetails[] = [];
  returnSegmentDetails: AirSegmentsDetails[] = [];
  airlineDetails:AirSegmentStopDetail[]=[];
  returnairlineDetails: AirSegmentStopDetail[] = [];
  RightsObj: InsuranceRightsObject = new InsuranceRightsObject();
  arrowRight = faArrowRight;
  upSquare = faUpRightFromSquare;
  faReply = faReply;
  tick=faCheck;
  linkIcon=faLink;
  lockIcon=faLock;
  clock= faClock;
  ValidationChck: boolean = false;
  continueBtn: boolean = false;
  numberOfPassengers:number=0;
  targetCountry: string = "";
  countryList: Countries[] = [];
  SchengenCountries: string[] = ['AT', 'BE', 'BG', 'HR', 'CZ', 'DK', 'EE', 'FI', 'FR', 'DE', 'GR', 'HU', 'IS', 'IT', 'LV', 'LI', 'LT', 'LU', 'MT', 'NL', 'NO', 'PL', 'PT', 'RO', 'SK', 'SI', 'ES', 'SE', 'CH'];
  constructor(private messageservice: MessageService, private cdr: ChangeDetectorRef, private userService: PassengerInfoService,
    public flightService: FlightSearchService, private router: Router, private agencyService: AgencyService, private insuranceService: InsuranceService) {
      this.router.events.subscribe((event) => {
        if (event instanceof NavigationStart) {
          window.localStorage.setItem('previousUrl', this.router.url);
        }
      });
  }
  childOptions = [
    {name: 1, code: 1},
    {name: 2, code: 2},
    {name: 3, code: 3}
  ]
  roeSubmission: boolean = false;
  noOFDays = [
    { name: '7 Days', code: 7 },
    { name: '10 Days', code: 10 },
    { name: '15 Days', code: 15 },
    { name: '21 Days', code: 21 },
    { name: '31 Days', code: 31 },
    { name: '62 Days', code: 62 },
    { name: '92 Days', code: 92 },
    { name: '180 Days', code: 180 },
    { name: '365 Days', code: 365 },
    { name: '2 Years', code: 2 },
  ];
  
  destination = [
    { name: 'Schengen states', code: 'SCH' },
    { name: 'Worldwide', code: 'WW' },
    { name: 'Rest of World (Excluding USA, CANADA & AUSTRALIA)', code: 'ROW' },
  
  ];
  numberOfChildren: null
  DetailsCompleted: boolean = false;
  currentYearLimit: number=0;
  yearLowerLimit: number = 0;
  travelDateLimit: number = 0;
  planTypes = [{ name: 'SINGLE', code: 'S' }, { name: 'FAMILY', code: 'F' }];
  selectedPlanType: string = "";
  spouseAccompany = [{ name: 'NO', value: false },{ name: 'YES', value: true }];
  BeneficiaryList = [
    {name: 'Brother', code: 'Brother'},
    {name: 'Father', code: 'Father'},
    {name: 'Mother', code: 'Mother'},
    {name: 'Sister', code: 'Sister'},
    {name: 'Husband', code: 'Husband'},
    {name: 'Wife', code: 'Wife'},
    {name: 'Son', code: 'Son'},
    {name: 'Daughter', code: 'Daughter'},
  ]
  minDate: string;
  maxDate: string;
  ngOnInit(){
      const today = new Date();
      this.currentYearLimit = today.getFullYear();
      this.yearLowerLimit = this.currentYearLimit - 75;
      this.travelDateLimit = this.currentYearLimit + 5;
      this.GetPackagesDetailByTravelPeriodWithCovidResList = [];
      this.numberOfPassengers = 0;
      
    this.agencyService.GetAgencyById("AG01").subscribe((data) => {
      this.passengerInfoBaseObj.principalTraveller.email = data.notificationEmail;
    });
    /*this.onStepFour();*/
    const Mytoday = new Date();
    this.minDate = Mytoday.toISOString().split('T')[0];
    this.maxDate = Mytoday.toISOString().split('T')[0];
    }
  ngOnDestroy(): void {
    localStorage.setItem('isReloaded', 'true');
  }
  filteredCountries: string[] = [];

  GetPackagesDetailByArea(){
    
  }
  searchCountrySuggestion(event) {
    let filtered: string[] = [];
    let query = event.query;

    for (let i = 0; i < this.countryList.length; i++) {
      let country = this.countryList[i];
      if (country.countryName.toLowerCase().indexOf(query.toLowerCase()) == 0) {
        filtered.push(country.countryName);
      }
    }
    this.filteredCountries = filtered;
  }
  isFamily: boolean = false;
  planTypeChange(event) {
  const ptype = event.value;
    if (ptype == 'S') {
      this.isFamily = false;
    } else if (ptype == 'F') {
      this.isFamily = true;
    }
  }
  NewCountryList: Countries[] = [];
  DestinationChange(event) {
    this.userService.getCountries().subscribe(data=>{
      this.countryList = data;
    });
    // if(event.value == 'SCH'){
    // }
    // else if(event.value == 'WW'){
    //   this.userService.getCountries().subscribe(data=>{
    //     this.countryList = data;
    //   });
    // }
    // else if(event.value == 'ROW'){
    //   this.userService.getCountries().subscribe(data=>{
    //     data.forEach(dataitem => {
    //       if(dataitem.countryName.toUpperCase() != 'CANADA' || dataitem.countryName.toUpperCase() != 'UNITED STATES OF AMERICA' || dataitem.countryName != 'AUSTRALIA')
    //       {
    //         this.countryList.push(dataitem);
    //       }
    //     });
    //   });
    // }
  }

  spouseChange(event) {
    const stype = event.value;
    this.passengerInfoBaseObj.isSpousePresent = Boolean(stype);
  }
    str:string="";
  
    allCoverageList: GetALLCoveragesDetailResponse[]=[];
    targetProducts: GetALLCoveragesDetailResponse[]=[];
    
    pickList() {
      this.insuranceService.GetALLCoveragesDetail().subscribe(products => {
          this.allCoverageList = products;
          this.cdr.markForCheck();
      });
      this.targetProducts = [];
    }
  onSpacePress(event: KeyboardEvent) {
    if (event.key === ' ') {
      event.preventDefault();
      (event.target as HTMLInputElement).value += '-';
    }
  }
  onRemarksSpacePress(event: KeyboardEvent) {
    if (event.key === ' ') {
      event.preventDefault();
      (event.target as HTMLTextAreaElement).value += '-';
    }
  }
  onDashPress(event: KeyboardEvent) {
    if (event.key === '-' || event.key === '_') {
      event.preventDefault();
      (event.target as HTMLInputElement).value += '';
    }
  }
  formatDOB(str): string {
    let arrPipe: DatePipe = new DatePipe('en-US');
    let paxdob = arrPipe.transform(str, "yyyy-MM-dd")!;
    paxdob = paxdob.split('T')[0];
    return paxdob;
  }
  isLoadPanelVisible: boolean = false;
  showDetails: boolean = false;
  notDetails: boolean = false;
  NOD: number;
  GetPackagesDetailByTravelPeriodWithCovidResList : GetPackagesDetailByTravelPeriodWithCovidResponse[] = [];
  GetPackagesDetailByTravelPeriodWithCovid() {
    if(this.passengerInfoBaseObj.destination == undefined || this.passengerInfoBaseObj.destination == '')
    {
      this.ValidationChck = true;
      return;
    }
    if(this.passengerInfoBaseObj.noOfDays == undefined || this.passengerInfoBaseObj.noOfDays < 0)
    {
      this.ValidationChck = true;
      return;
    }
    if(this.passengerInfoBaseObj.destinationCountry == undefined || this.passengerInfoBaseObj.destinationCountry == '')
    {
      this.ValidationChck = true;
      return;
    }
    if(this.passengerInfoBaseObj.travelDate == undefined || this.passengerInfoBaseObj.travelDate == '')
    {
      this.ValidationChck = true;
      return;
    }
    if(this.passengerInfoBaseObj.planType == undefined || this.passengerInfoBaseObj.planType == '')
    {
      this.ValidationChck = true;
      return;
    }
    if(this.passengerInfoBaseObj.planType == 'F' && (this.passengerInfoBaseObj.numberOfChildren == undefined || this.passengerInfoBaseObj.numberOfChildren == 0))
    {
      this.ValidationChck = true;
      return;
    }
    if(this.passengerInfoBaseObj.principalTraveller.nicNo == undefined || this.passengerInfoBaseObj.principalTraveller.nicNo == '')
    {
      this.ValidationChck = true;
      return;
    }
    if(this.passengerInfoBaseObj.principalTraveller.fullName == undefined || this.passengerInfoBaseObj.principalTraveller.fullName == '')
    {
      this.ValidationChck = true;
      return;
    }
    if(this.passengerInfoBaseObj.principalTraveller.dob == undefined || this.passengerInfoBaseObj.principalTraveller.dob == '')
    {
      this.ValidationChck = true;
      return;
    }
    if(this.passengerInfoBaseObj.principalTraveller.passportNo == undefined || this.passengerInfoBaseObj.principalTraveller.passportNo == '')
    {
      this.ValidationChck = true;
      return;   
    }
    if(this.passengerInfoBaseObj.principalTraveller.contactNo == undefined || this.passengerInfoBaseObj.principalTraveller.contactNo == '')
    {
      this.ValidationChck = true;
      return;
    }
    if(this.passengerInfoBaseObj.principalTraveller.ntnNo == undefined || this.passengerInfoBaseObj.principalTraveller.ntnNo == '')
    {
      this.ValidationChck = true;
      return;
    }
    if(this.passengerInfoBaseObj.principalTraveller.address == undefined || this.passengerInfoBaseObj.principalTraveller.address == '')
    {
      this.ValidationChck = true;
      return;
    }
    // this.isLoadPanelVisible = true;
    this.continueBtn = true;
    this.showDetails = false;
    this.notDetails = false;
    this.pickList();
    //let getPackagesDetailByTravelPeriodObj = new GetPackagesDetailByTravelPeriodWithCovidRequest();
    //getPackagesDetailByTravelPeriodObj.travelerName = this.TravelerName;
    //getPackagesDetailByTravelPeriodObj.nicNo = this.NICNo;
    this.passengerInfoBaseObj.principalTraveller.dob = this.formatDOB(this.passengerInfoBaseObj.principalTraveller.dob.toString());
    
    if (this.passengerInfoBaseObj.principalTraveller.spouseDOB != "" && this.passengerInfoBaseObj.principalTraveller.spouseDOB != null)
    this.passengerInfoBaseObj.principalTraveller.spouseDOB = this.formatDOB(this.passengerInfoBaseObj.principalTraveller.spouseDOB.toString());
    // if (this.passengerInfoBaseObj.principalTraveller.child1DOB != "" && this.passengerInfoBaseObj.principalTraveller.child1DOB != null)
    //   this.passengerInfoBaseObj.principalTraveller.child1DOB = this.formatDOB(this.passengerInfoBaseObj.principalTraveller.child1DOB.toString());
    // if (this.passengerInfoBaseObj.principalTraveller.child2DOB != "" && this.passengerInfoBaseObj.principalTraveller.child2DOB != null)
    //   this.passengerInfoBaseObj.principalTraveller.child2DOB = this.formatDOB(this.passengerInfoBaseObj.principalTraveller.child2DOB.toString());
    // if (this.passengerInfoBaseObj.principalTraveller.child3DOB != "" && this.passengerInfoBaseObj.principalTraveller.child3DOB != null)
    //   this.passengerInfoBaseObj.principalTraveller.child3DOB = this.formatDOB(this.passengerInfoBaseObj.principalTraveller.child3DOB.toString());
    
      
    //  getPackagesDetailByTravelPeriodObj.travelDays = this.NOD;
    //  getPackagesDetailByTravelPeriodObj.covid = this.Covid;
    //getPackagesDetailByTravelPeriodObj.ntnNo = "null";
    //this.passengerInfoBaseObj.principalTraveller.ntnNo = "null";
    this.passengerInfoBaseObj.parentHierarchy = localStorage.getItem("ParentHierarchy");
    this.passengerInfoBaseObj.agencyId = localStorage.getItem("AgencyId");
    this.passengerInfoBaseObj.creationUser = Number(localStorage.getItem("UserId"));
    this.passengerInfoBaseObj.noOfPassengers = 1;
    for (let ind = 0; ind < 1; ind++) {
      if (this.passengerInfoBaseObj.principalTraveller.spousePassport != "" && this.passengerInfoBaseObj.principalTraveller.spousePassport != null)
        this.passengerInfoBaseObj.noOfPassengers += 1;
      // if (this.passengerInfoBaseObj.principalTraveller.child1Passport != "" && this.passengerInfoBaseObj.principalTraveller.child1Passport != null)
      //   this.passengerInfoBaseObj.noOfPassengers += 1;
      // if (this.passengerInfoBaseObj.principalTraveller.child2Passport != "" && this.passengerInfoBaseObj.principalTraveller.child2Passport != null)
      //   this.passengerInfoBaseObj.noOfPassengers += 1;
      // if (this.passengerInfoBaseObj.principalTraveller.child3Passport != "" && this.passengerInfoBaseObj.principalTraveller.child3Passport != null)
      //   this.passengerInfoBaseObj.noOfPassengers += 1;
    }
    try {
      this.insuranceService.GetPackagesDetailByTravelPeriodWithCovid(this.passengerInfoBaseObj).subscribe(data => {
        if (data.length > 0 && data[0].responseCode == "USTI-S001") {
          this.GetInsuranceRight(data[0].supplierId, data[0].officeId);
          this.GetPackagesDetailByTravelPeriodWithCovidResList = data;
          localStorage.setItem("UtdInsAvailPlans", JSON.stringify(this.GetPackagesDetailByTravelPeriodWithCovidResList));
          this.showDetails = true;
          this.notDetails = false;
        } else {
          this.notDetails = true;
          this.showDetails = false;
        }
        setTimeout(() => { const fheight = document.body.scrollHeight; window.scroll(0, fheight); }, 1000);
        this.isLoadPanelVisible = false;
      });
    } catch (error) {
      console.log(error);
    }
    
  }
  insuranceRight= new InsuranceRights();
  GetInsuranceRight(supplierid, officeid) {
    this.RightsObj.agencyId = String(localStorage.getItem("AgencyId"));
    this.RightsObj.userId = Number(localStorage.getItem("UserId")).toString();
    this.RightsObj.supplierid = supplierid;
    this.RightsObj.officeid = officeid;
    this.insuranceService.CheckRightsInsurance(this.RightsObj).subscribe(data => {
      this.insuranceRight = data;
      localStorage.setItem("InsuranceIssueRights", JSON.stringify(this.insuranceRight));
    });
  }

areaShortCode:string | null;
UserName:string | null;
Password:string | null;
TravelDate:string | null;
TravelerName:string | null;
NoOfDays:string | null;
DOB:string | null;
PassportNo:string | null;
Address:string | null;
NICNo:string ="";
BeneficiaryName:string | null;
Relationship:string | null;
Country:string | null;
Remarks:string | null;
PlanType:string | null;
Plan:string | null;
Premium:string | null;
NTNNo:string | null;
TravelerEmail:string | null;
isRequestPolicy:boolean;
ReferenceNo:string | null;
ESystemName:string | null;
EUserName:string | null;
SrvSrce:string | null;
Covid:string ="NotCovered";
isCovidCovered:boolean;  
CovidCoverage(){
  if(this.isCovidCovered)
  {
    this.passengerInfoBaseObj.covid = "Covered";
  }
    else{
    this.passengerInfoBaseObj.covid = "NotCovered";
  }
}

  selectPackage(pkg: GetPackagesDetailByTravelPeriodWithCovidResponse) {
    if (!this.insuranceRight.book) {
      this.messageservice.add({ severity: 'error', summary: 'Rejected', detail: 'You have no Right to Book!' });

      return;
    }
    this.isLoadPanelVisible = true;
    this.passengerInfoBaseObj.areaShortCode = pkg.areaShortCode;
    this.passengerInfoBaseObj.travelDate = this.formatDOB(this.passengerInfoBaseObj.travelDate);
    this.passengerInfoBaseObj.remarks = "NA";
    this.passengerInfoBaseObj.planType = pkg.planType;
    this.passengerInfoBaseObj.plan=pkg.plan;
    this.passengerInfoBaseObj.premium = String(pkg.premium);
    //this.passengerInfoBaseObj.principalTraveller.ntnNo = "null";
    this.passengerInfoBaseObj.isRequestPolicy = true;
    this.passengerInfoBaseObj.referenceNo = pkg.usrRecID;
    this.passengerInfoBaseObj.eSystemName = this.passengerInfoBaseObj.principalTraveller.fullName;
    this.passengerInfoBaseObj.eUserName = this.passengerInfoBaseObj.principalTraveller.fullName;
    // this.passengerInfoBaseObj.vat = pkg.vat;
    // this.passengerInfoBaseObj.serviceFee = pkg.serviceFeeValue;
    // this.passengerInfoBaseObj.taxes = pkg.taxAmount;
    // this.passengerInfoBaseObj.discount = pkg.discountValue;
    // this.passengerInfoBaseObj.markup = pkg.markupValue;
    // this.passengerInfoBaseObj.totalRevenuePremium = String(pkg.totalMarkupAmount);
    this.onStepOne();
  }
  PackageBenefits:any[]=[];
  popoverArray: boolean[]=[];
  toggleWithAnimationOptions(index: number, pkg:GetPackagesDetailByTravelPeriodWithCovidResponse) {
    this.PackageBenefits=[];
    let lowerCase = pkg.plan.toLocaleLowerCase();
    if(lowerCase == "goldplus"){
      lowerCase = "goldPlus";
    }
    else if(lowerCase == "sapphireplus"){
      lowerCase = "sapphirePlus";
    }
    let word = lowerCase  + "Package" ;
    //let packagrBenefits:any[] = [];
  this.allCoverageList.filter((item:any)=>{
  let benefits;
  let packagee;
  for (const property in item) {
    if(property == word){
      packagee = item[property];
      benefits = item["benefits"];
      let oneObject = {benefits:benefits,price:packagee}
      this.PackageBenefits.push(oneObject);
    }  
  }
})
    //  for(let l=0; this.allCoverageList.length; l++){
    //          if(this.allCoverageList[l].silverPackage){
    //            this.PackageBenefits.push({"Benefits":this.allCoverageList[l].benefits,"Price":this.allCoverageList[l].standardPackage});
    //          }
    //        }
    this.popoverArray[index] = !this.popoverArray[index];
  }
  popVisible:boolean=false;
  togglePop(){
    this.popVisible=true;
  }

  onStepOne(){
    let reqObj = new GetCoveragesDetailbyAreaRequest();
    reqObj.areaShortCode = this.passengerInfoBaseObj.areaShortCode;
    this.insuranceService.GenerateUWDocument(this.passengerInfoBaseObj).subscribe(data => {
      if(data[0].responseCode == 'USTI:S-00001')
        {
          this.passengerInfoBaseObj.requestID = data[0].referenceID;
        this.onStepFour();
      }
    });
    // this.insuranceService.getPackagesDetailBenefitsbyArea(reqObj).subscribe(data => {
    //   this.isLoadPanelVisible = false;
    //   this.onStepTwo();
    // });
  }

  onStepTwo() {
    this.isLoadPanelVisible = true;
    let reqObj = new GetCountryDetailbyAreaRequest();
    reqObj.areaShortCode = this.passengerInfoBaseObj.areaShortCode;
    this.insuranceService.GetCountryDetailbyArea(reqObj).subscribe(data => {
      this.isLoadPanelVisible = false;
      if (data.length > 0) {
        data.forEach(ele => {
          if (ele.countryName == this.passengerInfoBaseObj.destinationCountry)
          this.onStepThree(ele.areaShortCode!);
        })
    }
  });
}

  
  onStepThree(countryShortCode: string) {
    this.isLoadPanelVisible = true;
    this.insuranceService.GenerateUWDocument(this.passengerInfoBaseObj).subscribe(data => {
    if(data[0].responseCode == 'USTI:S-00001')
      {
      this.onStepFour();
    }
  });
    
  }
  pendingReqList: GetRequestedUWDocumentDataResponse[]=[];
  onStepFour(){
    this.passengerInfoBaseObj.dataFor = "Pending";
    this.insuranceService.GetRequestedUWDocumentData(this.passengerInfoBaseObj).subscribe(data=>{
    if(data[data.length-1].responseCode == "USTI-S001"){
      this.pendingReqList = data;
      let reqPend = document.getElementById("step-4-insur") as HTMLDivElement;
      reqPend.style.height = "auto";
      reqPend.style.display = "block";
      setTimeout(() => { const height = document.body.scrollHeight; window.scroll(0, height); }, 1000);
      this.isLoadPanelVisible = false;
    //this.onStepFive(data[data.length-1].requestID);
    }
  });
  }

  priorityEntities = [{ id: 0, text: 'Issue' }, { id: 1, text: 'Cancel' }];
  selectionPriorityId: number;
  displayIssueCancel: boolean = false;

  showIssueCancelDialog() {
    this.displayIssueCancel = true;
  }
  insuranceData : TravelInsuranceDataProps[]=[];
  showGenerated: boolean = false;
  showDBError: boolean = false;
  onStepFive(Req: GetRequestedUWDocumentDataResponse) {
    if (!this.insuranceRight.issue) {
      this.messageservice.add({ severity: 'error', summary: 'Rejected', detail: 'You have no Right to Issue!' });

      return;
    }
  this.displayIssueCancel = false;
  this.isLoadPanelVisible = true;
  this.passengerInfoBaseObj.requestID = Req.requestID;
  if (this.selectionPriorityId == 0) {
    this.passengerInfoBaseObj.isCancelled = false;
  } else if (this.selectionPriorityId == 1) {
    this.passengerInfoBaseObj.isCancelled = true;
    this.passengerInfoBaseObj.remarks = Req.remarks;
  }
  //reqObj.cRemarks = "NM";
  //reqObj.eSystemName = this.passengerInfo[0].firstName+this.passengerInfo[0].lastName;
  //reqObj.eUserName = this.passengerInfo[0].firstName+this.passengerInfo[0].lastName;
  this.passengerInfoBaseObj.dataFor = "Pending";
  this.insuranceService.ProcessUWRequestData(this.passengerInfoBaseObj).subscribe(data => {
    for (let dc = 0; dc < data.length;dc++) {
      let insuranceData = new TravelInsuranceDataProps();
      insuranceData.bookingId = 0;
      insuranceData.referenceId = data[dc].referenceID;
      insuranceData.responseDescription = data[dc].responseDescription;
      insuranceData.requestId = data[dc].requestID;
      insuranceData.policyNo = data[dc].policyNo;
      insuranceData.insurancePlan = this.passengerInfoBaseObj.plan;
      insuranceData.planType = this.passengerInfoBaseObj.planType;
      insuranceData.status = data[dc].responseDescription;
      insuranceData.travelerName = data[dc].travelerName;
      if (data[dc].requestID == this.passengerInfoBaseObj.requestID) {
        insuranceData.premium = this.passengerInfoBaseObj.totalRevenuePremium;
      }
      insuranceData.policyURL = data[dc].policyPrintUrl;
      this.insuranceData.push(insuranceData);
    }
    this.passengerInfoBaseObj.proposalState = 1;
    this.passengerInfoBaseObj.policyPurchaseDate = new Date().toString();
    this.passengerInfoBaseObj.policyNo = this.insuranceData[0].policyNo;
    this.passengerInfoBaseObj.policyURL = this.insuranceData[0].policyURL;
    let dbObj: DBInsertProps = new DBInsertProps();

    this.insuranceService.InsertUniInsuranceDB(this.passengerInfoBaseObj).subscribe((res) => {
      if (res) {
        this.showGenerated = true;
      }
      else {
        this.showDBError = true;
      }
    });
    setTimeout(() => { const lheight = document.body.scrollHeight; window.scroll(0, lheight); }, 1000);
    this.isLoadPanelVisible = false;
  });
  }
  copyPolicyNo = async () => {
    let polNo = document.getElementById('textToCopy').innerHTML;
    try {
      await navigator.clipboard.writeText(polNo);
    } catch (err) {
      console.error('Failed to copy: ', err);
    }
  }
  toDashBoard() {
    this.router.navigateByUrl('zeusBookedPolicy');
  }
  selectedChild: number[] = [];
  selectedIndexChildren(event: any) {
    const count = event.value;
    this.selectedChild = Array.from({ length: count }, (_, i) => i + 1);
  
    // Initialize empty child objects if not already
    this.passengerInfoBaseObj.children = [];
  
    for (let i = 0; i < count; i++) {
      this.passengerInfoBaseObj.children[i] = this.passengerInfoBaseObj.children[i] || {
        name: '',
        dob: '',
        passport: ''
      };
    }
  }
}
